module.exports = __webpack_public_path__ + "media/applicants/iphone-298ec158.png";